import { ZONE_TYPE, ZONE_CAPACITY_TYPE, VISITOR_CATEGORY_TYPE } from 'src/features/zone/utils/types';
import { zoneMessages } from 'src/features/zone/utils/messages';

export const ZONE_TRANSLATION_MAP = {
    [ZONE_TYPE.REGULAR]: zoneMessages.regular,
    [ZONE_TYPE.VIP]: zoneMessages.vip,
    [ZONE_TYPE.EV]: zoneMessages.ev,
    [ZONE_TYPE.MOTORCYCLE]: zoneMessages.motorcycle,
    [ZONE_TYPE.BUFFER]: zoneMessages.buffer,
    [ZONE_TYPE.DISABLED]: zoneMessages.disabled,
};

export const ZONE_CAPACITY_TRANSLATION_MAP: Record<
    ZONE_CAPACITY_TYPE,
    { id: string; defaultMessage: string }
> = {
    [ZONE_CAPACITY_TYPE.CLIENT]: zoneMessages.client,
    [ZONE_CAPACITY_TYPE.VIP]: zoneMessages.vip,
    [ZONE_CAPACITY_TYPE.RESIDENT]: zoneMessages.resident,
    [ZONE_CAPACITY_TYPE.STAFF]: zoneMessages.staff,
    [ZONE_CAPACITY_TYPE.SERVICE]: zoneMessages.service,
    [ZONE_CAPACITY_TYPE.RESERVATION]: zoneMessages.reservation,
};

export const VISITOR_CATEGORIES_TRANSLATION_MAP: Record<
    VISITOR_CATEGORY_TYPE,
    { id: string; defaultMessage: string }
> = {
    // ...ZONE_CAPACITY_TRANSLATION_MAP,
    [VISITOR_CATEGORY_TYPE.CLIENT]: zoneMessages.client,
    [VISITOR_CATEGORY_TYPE.VIP]: zoneMessages.vip,
    [VISITOR_CATEGORY_TYPE.RESIDENT]: zoneMessages.resident,
    [VISITOR_CATEGORY_TYPE.STAFF]: zoneMessages.staff,
    [VISITOR_CATEGORY_TYPE.SERVICE]: zoneMessages.service,
    [VISITOR_CATEGORY_TYPE.RESERVATION]: zoneMessages.reservation,
    [VISITOR_CATEGORY_TYPE.SUBSCRIPTION]: zoneMessages.subscription,
};